import {Link} from "react-router";

export function NotFoundPage() {
    return (
        <div className="text-center py-5">
            <h1 className="display-6">Page not found</h1>
            <p className="text-body-secondary">There's nothing at this address.</p>
            <Link to="/">Go to the home page</Link>
        </div>
    );
}
